import { createFileRoute } from '@tanstack/react-router'
import { eduInternDetailsSearchSchema } from '@/features/my-edu-interns/intern-details/model/eduInternDetailsSearch'
import { EduInternDetailsPage } from '@/pages/internships/ui/EduInternDetailsPage'
export const Route = createFileRoute('/my-edu-interns_/$internId')({
  validateSearch: eduInternDetailsSearchSchema,
  component: Page,
})
function Page() {
  const { internId } = Route.useParams()
  return <EduInternDetailsPage internId={internId} />
}
